<template>
    <div class="login-form">
        <input type="text" v-model="login" placeholder="login">
        <input type="password" v-model="password" placeholder="password">
        <button class="button"
            v-on:click="send"
        >login</button>
        <span>{{message}}</span>        
    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    name: "LoginPanel",
    data() {
        return {
            login: "",
            password: "",
            message: ""
        }
    },
    methods: {
        ...mapActions(['getAccessToken']),
        async send() {
            //console.log(`${this.login} ${this.password}`);
            this.message = "";
            let token = await this.getAccessToken( {username: this.login, password: this.password});            
            if(token)
            {
                this.$router.push({name: "Tester"});
            }
            else{
                this.message = "Wrong login/password";
            }
        }
    },
}
</script>